import { AppRouteProps } from "@harea/component";
import React from "react";

const OvertimeRateContainer = React.lazy(() => import("./containers/OvertimeRateContainer"));

export const OvertimeRateRoutes: Array<AppRouteProps> = [
    {
        path: "overtime-rate",
        title: "std_overtime_rate_title",
        element: <OvertimeRateContainer />,
        roles: ["SUPER_ADMIN", "ADMIN", "DIRECTOR_HR"],
    },
];
